import Marquee from "react-fast-marquee";
import { Reveal, SectionLabel } from "./ui";
import { Linkedin, ArrowUpRight } from "lucide-react";

// Accepts either a full LinkedIn <iframe …> embed code or a plain embed URL.
function extractSrc(code) {
  if (!code) return null;
  const m = String(code).match(/src=["']([^"']+)["']/i);
  if (m) return m[1];
  const t = String(code).trim();
  return t.startsWith("http") ? t : null;
}

export default function LinkedInFeed({ posts = [], profile }) {
  const srcs = (posts || []).map(extractSrc).filter(Boolean);
  if (!srcs.length) return null;

  return (
    <section className="py-16 lg:py-20 bg-[var(--mf-mist)] border-t border-[var(--mf-line)] overflow-hidden">
      <div className="mf-container flex flex-wrap items-end justify-between gap-4">
        <div>
          <Reveal><SectionLabel><span className="inline-flex items-center gap-2"><Linkedin size={15} style={{ color: "#0A66C2" }} fill="currentColor" strokeWidth={0} /> Aktuelles auf LinkedIn</span></SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-head font-light tracking-tight text-2xl lg:text-3xl leading-tight mt-5 text-[var(--mf-ink)]">
              Beiträge von <span className="font-medium">Matthias Fenchel</span>.
            </h2>
          </Reveal>
        </div>
        {profile && (
          <a href={profile} target="_blank" rel="noopener noreferrer" data-testid="linkedin-follow-link"
             className="inline-flex items-center gap-2 text-sm font-semibold px-4 py-2.5 text-white rounded-sm transition-transform duration-300 hover:-translate-y-0.5"
             style={{ backgroundColor: "#0A66C2" }}>
            <Linkedin size={16} fill="currentColor" strokeWidth={0} /> Profil folgen <ArrowUpRight size={15} />
          </a>
        )}
      </div>

      <div className="mt-10" data-testid="linkedin-feed">
        <Marquee direction="left" speed={38} gradient={false} pauseOnHover autoFill>
          {srcs.map((src, i) => (
            <div key={i} data-testid={`linkedin-post-${i}`} className="mx-3 w-[340px] bg-white border border-[var(--mf-line)] overflow-hidden rounded-sm">
              <iframe
                src={src}
                title={`LinkedIn Beitrag ${i + 1}`}
                loading="lazy"
                className="w-full block"
                style={{ height: 430, border: 0 }}
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
